import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { notificationSettingsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type DeleteNotificationSettingsMutationProps = {
	userId: string;
	notificationSettingsId: string;
	refetchNotificationSettings: Function;
};

const useDeleteNotificationSettingsMutation = ({
	userId,
	notificationSettingsId,
	refetchNotificationSettings,
}: DeleteNotificationSettingsMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		(fieldId: string) => {
			return notificationSettingsService.deleteNotificationSettings({
				userId,
				notificationSettingsId,
				fieldId,
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				refetchNotificationSettings?.();
			},
		},
	);
};

export default useDeleteNotificationSettingsMutation;
